import moment from "moment-timezone";
import { Timezones } from "../utils/timezones";
export class TimezoneHelper {
  static getTimezoneObject(code: Record<string, any>): null | {
    label: string;
    name: any;
    offset: any;
    value: any;
  } {
    const timezoneList = Timezones;
    let timezoneObj = null;

    for (var key in timezoneList) {
      const timezoneArray = timezoneList[key].split(",");

      if (timezoneArray[0] === code) {
        timezoneObj = {
          offset: timezoneArray[1],
          value: timezoneArray[0],
          label: key,
          name: timezoneArray[2],
        };
      }
    }

    return timezoneObj;
  }

  static getTimezoneCode(value: string): null | string {
    const timezoneArray = value.split(",");
    let code = timezoneArray[0] || null;
    return code;
  }

  static getTimezoneOffset(value: string): null | string {
    const timezoneArray = value.split(",");
    let offset = timezoneArray[1] || null;
    return offset;
  }

  static detectUserTimeZone(): void {
    // Detect the user's timezone, and find the matching timezone in the ui static list of timezones.
    // First try to match the timezone name
    // If not found in the list of timezones, then try to match the offset in hours
    const browserTimeZone = moment.tz.guess(); // returns a string, eg "Europe/Dublin"

    const browserTimezoneOffset = -moment.tz.zone(browserTimeZone).parse() / 60; // gets the offset in hours

    let tzFound = false;
    let timezoneCode;
    Object.keys(Timezones).forEach(function (key) {
      if (Timezones[key].split(",")[2] === browserTimeZone && !tzFound) {
        timezoneCode = Timezones[key].split(",")[0];
        tzFound = true;
      }
    });

    if (!timezoneCode) {
      Object.keys(Timezones).forEach(function (key) {
        if (
          +Timezones[key].split(",")[1] === browserTimezoneOffset &&
          !tzFound
        ) {
          timezoneCode = Timezones[key].split(",")[0];
          tzFound = true;
        }
      });
    }

    return timezoneCode;
  }
}
